import __json from '../config/l10n.json';

type DataFromJson = {
	nameOrderLastFirst: readonly string[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
export const data: DataFromJson = __json as any;
